export const accountConstants = {
  ENERGY_DETAIL_REQUEST: "ACCOUNT_ENERGY_DETAIL_REQUEST",
  ENERGY_DETAIL_SUCCESS: "ACCOUNT_ENERGY_DETAIL_SUCCESS",
  ENERGY_DETAIL_FAILURE: "ACCOUNT_ENERGY_DETAIL_FAILURE",
  SUBMIT_REQUEST: "ACCOUNT_SUBMIT_REQUEST",
  SUBMIT_SUCCESS: "ACCOUNT_SUBMIT_SUCCESS",
  SUBMIT_FAILURE: "ACCOUNT_SUBMIT_FAILURE",
  SUBMIT_ALERT_REQUEST: "ACCOUNT_SUBMIT_ALERT_REQUEST",
  SUBMIT_ALERT_SUCCESS: "ACCOUNT_SUBMIT_ALERT_SUCCESS",
  SUBMIT_ALERT_FAILURE: "ACCOUNT_SUBMIT_ALERT_FAILURE",
  SUBMIT_EMAIL_REQUEST: "ACCOUNT_SUBMIT_EMAIL_REQUEST",
  SUBMIT_EMAIL_SUCCESS: "ACCOUNT_SUBMIT_EMAIL_SUCCESS",
  SUBMIT_EMAIL_FAILURE: "ACCOUNT_SUBMIT_EMAIL_FAILURE",
  TOGGLE_TAB: "ACCOUNT_TOGGLE_TAB"
};
